import { isEmpty } from 'es-toolkit/compat';
import { useMemo } from 'react';

import { useAppSelector } from '../configuration/setup/hooks';
import { getTenant, type Tenant } from '../configuration/tokenHandling/tokenSlice';
import { type MenuEntry, menuEntries } from '../data/menuEntries';
import { ServicesCategoriesList } from '../data/serviceData';
import { type ServiceCategories, useData } from './useData';

const byTenant = (tenant: Tenant) => (entry: MenuEntry) => entry.tenants.includes(tenant);

// Check if there are service items for this category.
// In case there are none, hide the menu entry
const byServices = (categories: ServiceCategories) => (entry: MenuEntry) => {
    if (ServicesCategoriesList.includes(entry.id)) {
        return !isEmpty(categories[entry.id]);
    }
    return true;
};

export const useMenu = () => {
    const tenant = useAppSelector(getTenant);
    const { dataCategories } = useData();

    return useMemo(() => {
        const items = tenant ? menuEntries.filter(byTenant(tenant)) : menuEntries;
        return items.filter(byServices(dataCategories)).filter(entry => entry.visible);
    }, [dataCategories, menuEntries, tenant]);
};
